// removed by extract-text-webpack-plugin
module.exports = {"sliderItemWrapper":"cZZ9FzcG1nsonTOcGvdj5","sliderItem":"OrkH-UIQhvs-WlzInR6BD","logoWrapper":"_2Nm4U38a56bXkt8DtA1bPZ","logo":"_2VOqJ-nesTM6_FL4qkJ7Di","description":"_1cdB0Y-hn0vMUg8j_VRzzC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalsCarousel/ProfessionalsCarousel.scss
// module id = 1678
// module chunks = 0